<template>
	<div class='animate-bounce'>
		<svg xmlns="http://www.w3.org/2000/svg" :width="width" viewBox="0 0 30.24 55" class="knd-pijl">
			<polygon :fill="kleur" points="27.16 37.57 17.05 47.01 17.05 0 12.52 0 12.52 46.39 3.08 37.57 0 40.89 15.12 55 30.24 40.89 27.16 37.57"/>
		</svg>
	</div>
</template>

<script>
	import './pijl.scss';
	export default {
		name: 'Pijl',
		props: ['kleur', 'width']
	}
</script>